/*
 * File: NavigationMenuItem.js
 * Project: patient-portal
 *
 * Created by Nate Weber on 08/12/2020
 *
 * Copyright (c) 2020 MacPractice, Inc. All rights reserved.
 *
 * Description: Individual menu item used for the main navigation
 * of the application.
 */

import React from "react";
import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";
import clsx from "clsx";

import { ButtonBase } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
  root: {
    boxSizing: "border-box",
    minWidth: 96,
    maxWidth: 168,
    color: theme.palette.common.white,
    flex: 1,
    borderBottom: `2px solid ${theme.palette.primary}`,
    "&:hover": {
      backgroundColor: theme.palette.primary.light,
      borderBottom: `2px solid ${theme.palette.primary.light}`
    }
  },
  height: theme.mixins.toolbar,
  active: {
    borderBottom: `2px solid ${theme.palette.common.white}`
  },
  wrapper: {
    display: "inline-flex",
    alignItems: "center",
    flexDirection: "column"
  },
  label: {
    fontFamily: theme.typography.fontFamily,
    fontSize: theme.typography.pxToRem(13),
    opacity: 1,
    marginTop: theme.spacing(0.5)
  }
}));

const NavigationMenuItem = ({ icon, label, ...rest }) => {
  const classes = useStyles();

  return (
    <ButtonBase
      component={NavLink}
      className={clsx(classes.root, classes.height)}
      activeClassName={classes.active}
      disableRipple
      {...rest}
    >
      <div className={classes.wrapper}>
        {icon}
        <div className={classes.label}>{label}</div>
      </div>
    </ButtonBase>
  );
};

NavigationMenuItem.propTypes = {
  icon: PropTypes.element.isRequired,
  label: PropTypes.string.isRequired,
  to: PropTypes.string.isRequired
};

export default NavigationMenuItem;
